import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import Start from "../src/scene/start";
import Scene1 from "../src/scene/scene1";
import Scene3 from "../src/scene/scene3";
import Scene2 from "../src/scene/scene2";
import End from "../src/scene/end";

export default function Index() {
	return (
		<Router>
			<Switch>
				<Route exact path="/">
					<Start />
				</Route>
				<Route path="/scene1">
					<Scene1 />
				</Route>
				<Route path="/scene2">
					<Scene2 />
				</Route>
				<Route path="/scene3">
					<Scene3 />
				</Route>
				<Route path="/fin">
					<End />
				</Route>
			</Switch>
		</Router>
	);
}
